<template>
  <div>
    <drawer @toggleSidebar="toggleSidebar" :sidebar="sidebar" />
    <Header @toggleSidebar="toggleSidebar" />
    <!--====== POST LAYOUT 1 PART START ======-->

    <section v-loading="isLoading" class="bg-white">
      <div class="container">
        <div class="pt-20 pb-20 pl-20 pr-20 lg:pl-105 lg:pr-105">
          <div class="row mt-40">
            <div class="col-lg-3 d-flex align-items-center mb-10">
              <img 
                :src="journal.coverurl" 
                :alt="journal.title" 
                class="mag-img"
              >
            </div>  
            <div class="col-lg-9 d-flex">
              <div class="magazine-info w-100">
                <div class="magazine-title">{{ journal.title }}</div>
                <div class="magazine-subtitle">{{ journal.abbreviation }}</div>
                <div class="info-item">
                  <div class="info-label">出版周期：</div>
                  <div class="info-value">{{ journal.period }}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">出版地：</div>
                  <div class="info-value">{{ journal.publishplace }}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">语言：</div>
                  <div class="info-value">{{ journal.language }}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">开本：</div>
                  <div class="info-value">{{ journal.size }}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">创刊时间：</div>
                  <div class="info-value">{{ journal.foundtime }}</div>
                </div>
              </div>
            </div>

            <div class="col-lg-12">        
              <div class="post-text mt-30">
                <div v-html="processedRichTextBody"></div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <!--====== POST LAYOUT 1 PART ENDS ======-->

    <footer-one />
    <!--====== GO TO TOP PART START ======-->
    <div class="go-top-area">
      <div class="go-top-wrap">
        <div class="go-top-btn-wrap">
          <a href="#" class="go-top go-top-btn d-block">
            <i class="fa fa-angle-double-up"></i>
            <i class="fa fa-angle-double-up"></i>
          </a>
        </div>
      </div>
    </div>
    <!--====== GO TO TOP PART ENDS ======-->
  </div>
</template>

<script>
import Header from "@/components/Utility/Header/index";
import FooterOne from "@/components/Utility/Footer/FooterOne.vue";
import Drawer from "@/components/Mobile/Drawer.vue";
import { formatTimestampToDate } from '@/utils/dateUtil';
import { getJournal } from "@/api/journal";

export default {
  components: { Header, FooterOne, Drawer },
  data: () => ({
    sidebar: false,
    isLoading: true,
    journal: {},
    richtextBody: '',
    processedRichTextBody: '',
  }),
  created() {
    document.addEventListener("scroll", this.topToBottom);
    this.fetchJournal();
  },
  methods: {
    toggleSidebar() {
      this.sidebar = !this.sidebar;
    },
    topToBottom() {
      const result = document.querySelector(".go-top");
      if (
        document.body.scrollTop > window.innerHeight ||
        document.documentElement.scrollTop > window.innerHeight
      ) {
        result.classList.add("active");
      } else {
        result.classList.remove("active");
      }
    },
    async fetchJournal() {
      const journalId = this.$route.params.id; 
      if (journalId) {
        try {
          const response = await getJournal(journalId);
          this.journal = response.data; 
          console.log(this.journal);

          this.prevArticle = response.prev;
          this.nextArticle = response.next;
        
        } catch (error) {
          console.error('获取文章数据失败:', error);
        } finally {
          // 无论请求成功或失败，都结束加载状态
          this.isLoading = false;
        }
      }
    },
    formatTimestampToDate,
  },
};
</script>

<style>
.mag-img {
  width: 200px; /* 图片宽度 */
  height: auto;
  object-fit: cover;
}

.magazine-info {
  flex: 1; /* 文字区域占据剩余空间 */
  display: flex; /* 使用flex布局 */
  flex-direction: column; /* 垂直方向排列 */
  justify-content: space-around; /* 垂直均匀分布 */
  height: 100%;
}

.magazine-title {
  font-size: 24px;
  font-weight: bold;
}
.magazine-subtitle {
  font-size: 16px;
  color: #666;
  margin-bottom: 10px;
}
.info-item {
  display: flex;
  margin-bottom: 4px;
}
.info-label {
  font-weight: 500;
  color: #333;
  min-width: 100px;
}
.info-value {
  color: #666;
  flex: 1;
}
</style>
